import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { ExpensePageFinanceCustomCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  subcategories: ExpensePageFinanceCustomCategoryFragment[]
}
const subcategoryFilter = ({
  subcategories,
  expensesContext,
  initialFilterValues,
}: Props): DataTableFilter<ExpensesExpensableFilter> => {
  const options = subcategories.map((subcategory) => ({
    label: subcategory.label,
    value: subcategory.identifier,
  }))

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: initialFilterValues.subcategory ? [initialFilterValues.subcategory] : [],
      },
    ],
    onUpdateValue: () => {
      trackFilters('subcategory', expensesContext)
    },
    identifier: 'expensesList.subcategoryFilter',
    path: 'subcategory',
    title: i18n.t('expenses_v2.forms.fields.subcategory.label'),
    default: !!initialFilterValues.subcategory,
  }
}

export default subcategoryFilter
